import { unsafeFetch } from "@/lib/fetch";
import environment, { apiUrls } from "@/modules/environment";
import { UserSession } from "../user/User";

type Options = { path?: string; rethrow?: boolean; method?: string };
const headers = {
  "Content-Type": "text/plain"
};

async function run(
  func: string,
  body?: object,
  { path = "functions", rethrow = false, method = "POST" }: Options = {}
) {
  try {
    const sessionToken = UserSession.get()?.sessionToken;
    const response = await unsafeFetch(`${apiUrls.parseUrl}/${path}/${func}`, {
      headers,
      body: JSON.stringify({
        ...(sessionToken && { _SessionToken: sessionToken }),
        _ApplicationId: environment.appName,
        ...body
      }),
      method
    });
    return response;
  } catch (err: any) {
    if (rethrow) throw err;
    return null;
  }
}

class SSRCloud {
  sessionToken: string | undefined;
  constructor(sessionToken?: string) {
    this.sessionToken = sessionToken;
  }

  run = async (func: string, body?: object, { path = "functions", rethrow = false, method = "POST" }: Options = {}) => {
    try {
      const response = await unsafeFetch(`${apiUrls.parseUrl}/${path}/${func}`, {
        headers,
        body: JSON.stringify({
          ...(this.sessionToken && { _SessionToken: this.sessionToken }),
          _ApplicationId: environment.appName,
          ...body
        }),
        method
      });
      return response;
    } catch (err: any) {
      if (rethrow) throw err;
      return null;
    }
  };
}

const Cloud = { run };

export { Cloud, SSRCloud };
